import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    data: {
        promociones: [],
        promoEdit: {},
        imagen: null,
        imagenOriginal: null,
    }
})

export default function Reducer(state = initialState, action) {
    
    if(action.type === ReducerActions.SAVE_PROMOCIONES){
        return state
        .setIn(["data", "promociones"], action.payload)
        .setIn(["data", "promoEdit"], {})
    }    
    if(action.type === ReducerActions.SAVE_PROMOCION_EDIT){
        return state.setIn(["data", "promoEdit"], action.payload )
    }
    if(action.type === ReducerActions.SAVE_IMAGEN_PROMOCIONES){
        return state
        .setIn(["data", "imagen"], action.payload[0] )
        .setIn(["data", "imagenOriginal"], action.payload[1] )
    }
    return state
}